import { StatusBadge } from "./StatusBadge";
import { stageLabelOf, type StageLabels } from "../hooks/useProductionStageLabels";

/**
 * Sipariş statü rozeti — sipariş üretimdeyse ATÖLYE AŞAMASIYLA birlikte.
 *
 * "Üretimde" tek başına müşteriye ya da ofise bir şey söylemiyor: iş henüz
 * planlamada da olabilir, paketlemede de. Aynı soru ("sipariş ne durumda?")
 * her seferinde üretim kaydını ayrıca açtırıyordu. Rozet artık
 * "Üretimde (Cnc)", "Üretimde (Paketleme)" der.
 *
 * Aşama yalnızca sipariş ÜRETİMDEYKEN eklenir. Kargoya verilmiş ya da
 * tamamlanmış siparişin yanında "(Tamamlanan Üretim)" yazmak bilgi değil
 * gürültüdür; o durumlar için sipariş detayındaki "Üretim aşaması" satırı var.
 */

/** Sözlükteki kimlik — `functions/src/core/statusIds.ts` → `ORDER_STATUS.inProduction`. */
export const IN_PRODUCTION_STATUS = "wc-uretimde";

export function orderStatusText(
  o: { erpStatus?: string | null; erpStatusLabel?: string | null; productionStatus?: string | null },
  stages: StageLabels,
): string {
  const base = (o.erpStatusLabel ?? "").trim() || o.erpStatus || "—";
  if (o.erpStatus !== IN_PRODUCTION_STATUS) return base;
  const stage = stageLabelOf(stages, o.productionStatus);
  return stage ? `${base} (${stage})` : base;
}

interface OrderStatusBadgeProps {
  erpStatus?: string | null;
  erpStatusLabel?: string | null;
  productionStatus?: string | null;
  stages: StageLabels;
  size?: "sm" | "md";
}

export function OrderStatusBadge({ stages, size, ...o }: OrderStatusBadgeProps) {
  return (
    <StatusBadge label={orderStatusText(o, stages)} technicName={o.erpStatus} size={size} />
  );
}

export default OrderStatusBadge;
